import { useEffect, useState } from "react";

const ErrorFallback = () => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown === 0) {
      window.location.assign("/");
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 gap-3">
      <p className="fs-4">⚠️ Er is iets fout gegaan.</p>
      <p className="text-muted">
        U wordt over <strong>{countdown}</strong> seconde
        {countdown !== 1 ? "n" : ""} doorverwezen naar de startpagina.
      </p>
    </div>
  );
};

export default ErrorFallback;
